import { Address } from '@freighthub/freighthub-corelib'

import { TransportMode } from './transportMode'
import { TransportType } from './transportType'

export const SHIPMENT_STATES = ['new', 'active', 'completed', 'closed', 'canceled'] as const
export type ShipmentState = (typeof SHIPMENT_STATES)[number]
export type Shipment = {
  id: string
  demo: boolean
  mq: boolean
  customs: boolean
  customer_id: string
  customer: string
  type: TransportType
  mode: TransportMode
  state: ShipmentState
  created_at: string
  star: boolean
  added_service: never[]
  required_actions_count: number
  important: boolean
  triangular: boolean
  dangerous_goods: boolean
  invoice_number: never[]
  _hasChecklist: boolean
  _origin: {
    address: Address
    port: {
      name: string
      iataCode: string
      id: string
    }
  }
  _destination: {
    port: {
      name: string
      iataCode: string
      id: string
    }
    address: Address
  }
  _id_num: number
  _cargo: {
    volume: number
    grossWeight: number
    quantity: number
    width: number
    length: number
    type: string
    commodityType: string
    height: number
  }[]
  is_eligible_for_shipment_health_check: boolean
  pod: string
  destination: string
  delivery_long: string
  _tpScheme_timestamp: number
  container_quantity: number
  etd?: string
  eta?: string
  pol: string
  onCarriageMode: string
  carrier_id: string
  oi_shipment_id: never[]
  on_carriage_provider: string[]
  container_customer_reference: never[]
  seal_number: never[]
  delivery: string
  _delivery_date?: string
  _pickup_date?: string
  carrier: string[]
  'co-loader': never[]
  container_number: never[]
  pre_carriage_provider: never[]
  _shipment_timestamp: number
  shipper: string
  sales: string
  shipper_contact_name: string
  chargeable_weight: number
  originOps: string
  ops: string
  incoterm: string
  consignee_contact_name: string
  booking_date: string
  shipmentIncidents: never[]
  bl: never[]
  customer_reference: string
  total_eur: number
  class: string
  cargo_ready_date?: string
  logex_team: string
  atc_number: never[]
  awb: never[]
  _subscribers_timestamp: number
  subscribers: string[]
  _health_timestamp: number
  health_violated_rules: string[]
  health_number_of_violated_rules: number
  _health_retrieval_error_happened: boolean
  health_score: number
  _nextTask_timestamp: number
  due_date?: string
  next_task_priority?: number
  start_date?: string
  _quoteOption_timestamp: number
  carbonOffset: string
  _requiredActions_timestamp: number
  _financeBook_timestamp: number
}
